import { gql } from "@apollo/client";

export const GET_FABRIC_GROUPS = gql`
  query GET_FABRIC_GROUPS(
    $searchTerm: String
    $language: EnumLanguageFilter
    $take: Int
    $skip: Int
    $orderBy: [FabricGroupOrderByWithRelationInput!]
    $filters: [FabricGroupWhereInput]
  ) {
    findManyFabricGroupCount(
      where: {
        OR: [
          {
            fabric_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: $language
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
    )

    findManyFabricGroup(
      orderBy: $orderBy
      where: {
        OR: [
          {
            fabric_group_profiles: {
              some: {
                name: { mode: insensitive, contains: $searchTerm }
                language: $language
              }
            }
          }
          { code: { mode: insensitive, contains: $searchTerm } }
        ]
        AND: $filters
      }
      take: $take
      skip: $skip
    ) {
      id
      code
      createdAt
      fabric_group_profiles {
        id
        name
        language
      }

      manufacturer {
        id
        company_name
        manufacturer_profiles {
          name
          language
        }
      }

      type

      fabrics {
        id
      }
    }
  }
`;

export const DELETE_MANY_FABRICS = gql`
  mutation DELETE_MANY_FABRICS($ids: [Int!]!) {
    deleteManyFabricGroup(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const CORE_FABRIC_GROUP_DATA = gql`
  fragment CoreFabricGroupData on FabricGroup {
    id
    # createdAt
    type
    code
    fabric_group_profiles {
      id
      name
      description
      language
    }

    manufacturer {
      id
    }

    fabrics {
      id
      code
      color_name
      order
      image {
        src
      }
    }

    water_repelant
    virus_protection
    non_flammable
    pet_friendly
    environment_friendly
    easy_water_cleaning

    link_to_manufacturer_page
  }
`;

export const UPDATE_FABRIC_GROUP = gql`
  mutation UPDATE_FABRIC_GROUP(
    $where: FabricGroupWhereUniqueInput!
    $fabric_group_profiles: [FabricGroupProfileCustomInput!]!
    $fabrics: [FabricCustomInput!]!
    $manufacturer: Int!
    $fabric_type: FabricType!
    $water_repelant: Boolean!
    $virus_protection: Boolean!
    $non_flammable: Boolean!
    $pet_friendly: Boolean!
    $environment_friendly: Boolean!
    $easy_water_cleaning: Boolean!
    $link_to_manufacturer_page: String
    $code: String
  ) {
    updateExistingFabricGroup(
      where: $where
      fabric_group_profiles: $fabric_group_profiles
      fabrics: $fabrics
      manufacturer: $manufacturer
      fabric_type: $fabric_type
      water_repelant: $water_repelant
      virus_protection: $virus_protection
      non_flammable: $non_flammable
      pet_friendly: $pet_friendly
      environment_friendly: $environment_friendly
      easy_water_cleaning: $easy_water_cleaning
      link_to_manufacturer_page: $link_to_manufacturer_page
      code: $code
    ) {
      id
    }
  }
`;

export const CREATE_FABRIC_GROUP = gql`
  mutation CREATE_FABRIC_GROUP(
    $fabric_group_profiles: [FabricGroupProfileCustomInput!]!
    $fabrics: [FabricCustomInput!]!
    $manufacturer: Int!
    $fabric_type: FabricType!
    $water_repelant: Boolean!
    $virus_protection: Boolean!
    $non_flammable: Boolean!
    $pet_friendly: Boolean!
    $environment_friendly: Boolean!
    $easy_water_cleaning: Boolean!
    $link_to_manufacturer_page: String
    $code: String
  ) {
    createNewFabricGroup(
      fabric_group_profiles: $fabric_group_profiles
      fabrics: $fabrics
      manufacturer: $manufacturer
      fabric_type: $fabric_type
      water_repelant: $water_repelant
      virus_protection: $virus_protection
      non_flammable: $non_flammable
      pet_friendly: $pet_friendly
      environment_friendly: $environment_friendly
      easy_water_cleaning: $easy_water_cleaning
      link_to_manufacturer_page: $link_to_manufacturer_page
      code: $code
    ) {
      # ...CoreCollectionData
      id
    }
  }
`;

export const GET_FABRIC_GROUP = gql`
  query GET_FABRIC_GROUP($id: Int!) {
    findUniqueFabricGroup(where: { id: $id }) {
      id
      type
      code
      fabric_group_profiles {
        id
        name
        description
        language
      }
      manufacturer {
        id
      }
      fabrics {
        id
        code
        color_name
        order
        image {
          src
        }
      }
      water_repelant
      virus_protection
      non_flammable
      pet_friendly
      environment_friendly
      easy_water_cleaning
      link_to_manufacturer_page
    }
  }
`;
